import React from "react";
import Table from "../../components/Table";

export default function Remittances() {
    return <Table type="remittance"/>;
}
